import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { COOKIE_KEY_EMAIL } from '../../../constants/cookie';

import { lockEbons } from '../../../services/ebon/actions';

import {
    getUserId,
    getClickId,
    getLastUserInfoStored,
    getFraudScore,
    getHash
} from '../../../utils/plebicardUtils';
import gtm from '../../../utils/gtmUtils';
import { catchUserLastEbonInfo } from '../../../utils/storageUtils';

import AddressForm from './AddressForm';

import { FunnelAddressContainer } from './FunnelAddressStepStyle';

const FunnelAddressStep = ({
    partnerId,
    setUserInfo,
    merchantCardPath,
    ebon,
    form,
    lockEbons,
    lockFetching,
    lockFailure,
    createOrderRequest,
    userId
}) => {
    const [cappingError, setCappingError] = useState(false);

    const clickId = getClickId();
    const userLastEbonInfoStored = getLastUserInfoStored();
    const score = getFraudScore();
    const hash = getHash();

    const hasFreeFacial = ebon.ebons.freeFacialValue !== undefined;

    const isFetching = lockFetching || createOrderRequest;

    const FORM_NAME = 'ebonbilling-form';

    // Do lock
    const handleSubmit = async () => {
        const formData = form[FORM_NAME].values;

        let number = formData.phoneNumber;
        if (!number.startsWith('+')) {
            number = `+33${number.startsWith('0') ? number.substring(1, number.length) : number}`;
        }

        const tempUserInfo = {
            lastname: formData.lastname,
            firstname: formData.firstname,
            billingAdressLine1: formData.address,
            billingAdressLine2: formData.address,
            billingAdress: formData.address,
            billingCity: formData.city,
            billingPostalCode: formData.zipCode,
            billingCountry: formData.country,
            email: formData.email,
            message: formData.message,
            phoneNumber: number,
            userId: userId,
            clickId: clickId
        };

        const ebonCart = {
            lockRequests: ebon.cart,
            userId: userId,
            purchaseTrackingId: clickId,
            partnerId: partnerId,
            fixedFacialValue: !hasFreeFacial
        };

        catchUserLastEbonInfo(
            formData.email,
            number,
            formData.firstname,
            formData.lastname,
            formData.address,
            formData.zipCode,
            formData.city,
            'FR'
        );
        setUserInfo(tempUserInfo);
        sessionStorage.setItem(COOKIE_KEY_EMAIL, formData.email);

        gtm.event('add_shipping_info', { ...tempUserInfo });

        lockEbons(formData.email, ebonCart, userId, clickId, score, hash, number);
    };

    // Handle lock failure
    useEffect(() => {
        if (!isEmpty(lockFailure)) {
            // Check user capping
            if (lockFailure.statusCode === 406) {
                setCappingError(true);
            }
        }
    }, [lockFailure]);

    return (
        <FunnelAddressContainer>
            <AddressForm
                formName={FORM_NAME}
                initialValues={userLastEbonInfoStored}
                cappingError={cappingError}
                isFetching={isFetching}
                handleSubmit={handleSubmit}
                merchantCardPath={merchantCardPath}
            />
        </FunnelAddressContainer>
    );
};

FunnelAddressStep.propTypes = {
    partnerId: PropTypes.number,
    partnerName: PropTypes.string,
    setUserInfo: PropTypes.func,
    merchantCardPath: PropTypes.string
};

const mapStateToProps = (state, ownProps) => {
    return {
        ebon: state.ebon,
        form: state.form,
        lock: state.ebon.lock,
        lockFetching: state.ebon.lockFetching,
        lockFailure: state.ebon.lockFailure,
        createOrderRequest: state.ebon.createOrderRequest,
        userId: getUserId(state)
    };
};

const mapDispatchToProps = {
    lockEbons
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FunnelAddressStep));



// WEBPACK FOOTER //
// ./src/components/funnel/address-step/FunnelAddressStep.js